import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProcessIntelligenceComponent } from './process-intelligence.component';
import { processIntelligenceRoutingModule } from './process-intelligence-routing.module';
import { IntelligenceDashboardComponent } from './intelligence-dashboard/intelligence-dashboard.component';
import { IntelligenceCanvasComponent } from './intelligence-canvas/intelligence-canvas.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatTreeModule } from '@angular/material/tree';
import { MatMenuModule } from '@angular/material/menu';



@NgModule({
  declarations: [ProcessIntelligenceComponent, IntelligenceDashboardComponent, IntelligenceCanvasComponent],
  imports: [
    CommonModule,
    processIntelligenceRoutingModule,
    MatExpansionModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    DragDropModule,
    MatCheckboxModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatRadioModule,
    MatTreeModule,
    MatMenuModule
  ]
})
export class ProcessIntelligenceModule { }
